import type { ReactNode } from "react";
import { ChartBar, Globe2, Maximize2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { PALETTE } from "./constants";
import { RANKING_FONT, rankingSeriesColor } from "./rankingTheme";
import { ChartCardPanel } from "./ChartCardPanel";

const Panel = styled(ChartCardPanel)`
	height: 100%;
	*, *::before, *::after { box-sizing: border-box; }
	.body { font: 13px/1.45 ${RANKING_FONT}; }
	.report { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 32px; height: 32px; padding: 0; border: 1px solid #e1e6ef; border-radius: 7px; background: #fff; color: #667085; cursor: pointer; }
	.report:hover { color: #167ca6; background: #f6f8fb; }
	.report:focus-visible { outline: 2px solid #167ca6; outline-offset: 3px; border-radius: 3px; }
	@media (pointer: coarse) { .report { width: 44px; height: 44px; } }
`;

const Legend = styled.ul`
	display: flex;
	flex-wrap: wrap;
	gap: 4px 16px;
	margin: 0 0 10px;
	padding: 0;
	list-style: none;
	font: 12px/1.45 ${RANKING_FONT};
	color: #667085;
	li { display: flex; align-items: center; gap: 6px; min-width: 0; overflow-wrap: anywhere; }
	span { width: 7px; height: 7px; flex-shrink: 0; border-radius: 2px; }
`;

export const RankingLegend = ({ labels, colors }: { labels: string[]; colors: string[] }) => labels.length > 0 ? <Legend>
	{labels.map((label, index) => <li key={index}><span aria-hidden="true" style={{ background: rankingSeriesColor(colors[index % colors.length] ?? PALETTE[index % PALETTE.length]) }} />{label}</li>)}
</Legend> : null;

export const RankingCard = ({ title, icon, onFullReport, children }: { title: string; icon?: "country"; onFullReport?: () => void; children: ReactNode }) => {
	const { t } = useTranslation();
	const Icon = icon === "country" ? Globe2 : ChartBar;
	return <Panel aria-label={title}>
		<div className="header"><h3><Icon size={20} aria-hidden="true" /><span>{title}</span></h3>{onFullReport && <button type="button" className="report" aria-label={t("stats.fullReport")} title={t("stats.fullReport")} aria-haspopup="dialog" onClick={onFullReport}><Maximize2 size={16} aria-hidden="true" /></button>}</div>
		<div className="body">{children}</div>
	</Panel>;
};
